"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.AnswerContainer = void 0;
const react_1 = __importStar(require("react"));
const styled_components_1 = __importStar(require("styled-components"));
const GlobalStateProvider_1 = require("../../../../GlobalStateProvider");
const AnswerStyled = styled_components_1.default.div `
	${props => (props.$isMobile ? mobileStyles : desktopStyles)}
`;
const mobileStyles = (0, styled_components_1.css) `
	display: grid;
	grid-template-columns: repeat(5, 1fr);
	width: 100%;
	gap: 12px;
	align-items: center;
	padding: 0px 4px 0px 4px;

	.submit {
		position: relative;
		cursor: pointer;

		.frame {
			border-radius: 50px;
			border-style: solid;
			border-color: var(--color-black, #101010);
			border-width: 1px;
			padding: 4px 10px 4px 10px;
			display: flex;
			flex-direction: row;
			gap: 10px;
			align-items: center;
			justify-content: center;
			flex-shrink: 0;
			width: 26px;
			height: 26px;
			position: relative;
		}
		.value {
			color: var(--color-black, #101010);
			text-align: center;
			font-family: 'Noto Sans KR', sans-serif;
			font-size: 12px;
			line-height: 150%;
			letter-spacing: -0.02em;
			font-weight: 400;
			position: relative;
		}

		/* 선택 답안(번호 클릭)은 테두리 색 변경만으로는 시인성이 낮아 원 내부를 채운다(Solid Fill).
		   테두리 색도 배경과 같게 맞춰 선택 전/후 원 크기가 변하지 않도록 한다. */
		&.active {
			.frame {
				background: var(--color-pink, #f46790);
				border-color: var(--color-pink, #f46790);
			}

			.value {
				color: var(--color-white, #ffffff);
			}
		}
	}
`;
const desktopStyles = (0, styled_components_1.css) `
	display: grid;
	grid-template-columns: repeat(5, 1fr);
	width: 100%;
	gap: 10px;

	.submit {
		position: relative;
		cursor: pointer;

		.frame {
			border-radius: 50px;
			border-style: solid;
			border-color: var(--color-black, #101010);
			border-width: 1px;
			display: flex;
			flex-direction: row;
			gap: 10px;
			align-items: center;
			justify-content: center;
			flex-shrink: 0;
			position: relative;
			width: 28px;
			height: 28px;
		}
		.value {
			color: var(--color-black, #101010);
			text-align: center;
			font-family: var(--b4-font-family, 'Noto Sans KR', sans-serif);
			font-size: var(--b4-font-size, 14px);
			line-height: var(--b4-line-height, 28px);
			font-weight: var(--b4-font-weight, 400);
			position: relative;
		}

		/* 선택 답안(번호 클릭)은 테두리 색 변경만으로는 시인성이 낮아 원 내부를 채운다(Solid Fill).
		   테두리 색도 배경과 같게 맞춰 선택 전/후 원 크기가 변하지 않도록 한다. */
		&.active {
			.frame {
				background: var(--color-pink, #f46790);
				border-color: var(--color-pink, #f46790);
			}

			.value {
				color: var(--color-white, #ffffff);
			}
		}
	}
`;
const AnswerContainer = ({ defaultValue = 0, isOnlyAnswer = false, maxCount, onChange, }) => {
    const { isMobile } = (0, GlobalStateProvider_1.useGlobalState)();
    const [number, setNumber] = (0, react_1.useState)(defaultValue);
    const containers = (0, react_1.useMemo)(() => {
        if (isOnlyAnswer) {
            return (react_1.default.createElement("div", { className: "submit" },
                react_1.default.createElement("div", { className: "frame" },
                    react_1.default.createElement("div", { className: "value" }, defaultValue))));
        }
        const arr = [];
        for (let i = 0; i < maxCount; i++) {
            arr.push(react_1.default.createElement("div", { className: `submit ${number === i + 1 ? 'active' : ''}`, onClick: () => {
                    onChange(i + 1);
                    setNumber(i + 1);
                }, key: i },
                react_1.default.createElement("div", { className: "frame" },
                    react_1.default.createElement("div", { className: "value" }, i + 1))));
        }
        return arr;
    }, [onChange]);
    return react_1.default.createElement(AnswerStyled, { "$isMobile": isMobile }, containers);
};
exports.AnswerContainer = AnswerContainer;
